import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { useQuery } from "@apollo/client";

interface IVendorPickerProps {
  handleChange: (stageId: string) => void;
  defaultValue?: string;
  value: string|undefined;
}

export const ArtistLinkTypePicker = ({
  handleChange,
  defaultValue,
  value,
}: IVendorPickerProps) => {
  const data = ['artist', 'vendor']

  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">Link Type</InputLabel>
      <Select
        labelId="artist-link-type-label"
        id="artist-link-type-select"
        value={value}
        label="Link Type"
        defaultValue={defaultValue}
        onChange={(event) => handleChange(event.target.value)}
      >
        {data?.map((key) => {
          return <MenuItem value={key}>{key}</MenuItem>;
        })}
      </Select>
    </FormControl>
  );
};
